import { Box } from '@mui/material';
import { getNewsQuery } from 'api/queries/global';
import NewsModal from 'components/Modals/NewsModal';
import { useEffect, useState } from 'react';
import { NewsType } from './types';

const News = () => {
    const [shownNews, setShownNews] = useState<string>('');
    const [news, setNews] = useState<NewsType[]>([]);

    useEffect(() => {
        getNewsQuery(setNews, setShownNews);
    }, []);

    const selectedOne = news.find((item) => item.document_id === shownNews);

    return selectedOne ? (
        <Box className="news-modal-container">
            <NewsModal open={true} news={selectedOne} />
        </Box>
    ) : null;
};

export default News;
